import { getApiUrl } from '@/app/utils/api';
import {
  clearPendingReferralCode,
  getPendingReferralCode,
} from '@/app/lib/pending-referral';

/**
 * Ensures the Privy user row exists, then binds referer from pending referral code if any.
 * Clears storage when bind succeeds or when the server returns a final error.
 */
export async function applyPendingReferralForUser(privyId: string): Promise<void> {
  const code = getPendingReferralCode();
  if (!code) return;

  try {
    await fetch(getApiUrl('api/users/verify'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ privy_id: privyId }),
    });

    const res = await fetch(getApiUrl('api/user-bind-referral'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ privyId, code }),
    });

    const json = (await res.json().catch(() => ({}))) as {
      ok?: boolean;
      error?: string;
    };

    if (json?.ok === true) {
      clearPendingReferralCode();
      return;
    }

    const err = json?.error;
    if (
      err === 'already_bound' ||
      err === 'own_code' ||
      err === 'code_not_found' ||
      err === 'invalid_code'
    ) {
      clearPendingReferralCode();
    }
  } catch (e) {
    console.error('applyPendingReferralForUser failed:', e);
  }
}
